// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionsCarousel-cls1___0a03d4742a5f5562e73","cls2":"SuggestionsCarousel-cls2___26451a79b425789221f SuggestionsCarousel-cls1___0a03d4742a5f5562e73"};